import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

// import Header from './Header';
// import Footer from './Footer';

const About = () => {
  return (
    <>
      {/* <Header /> */}
      <div className="breadcumb-wrapper" style={{ backgroundImage: `url('assets/img/hero/slider1.jpg')`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
        {/* <div className="breadcumb-wrapper" data-bg-src="assets/img/hero/slider1.jpg"> */}
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">
              About
              <br />
              Divyakshetra Hariharapura
            </h1>
          </div>
        </div>
      </div>
      <div className="about-area overflow-hidden space pb-0" id="about-sec">
        <div className="container">
          <div className="row gy-5">
            <div
              className="space overflow-hidden positive-relative overflow-hidden"
              style={{ backgroundImage: "url(assets/img/sevas_bg.png)" }}
            >
              <div className="container">
                <div className="title-area text-center">
                  <span
                    className="sub-title text-anime-style-2"
                    style={{ color: "var(--theme-color2)" }}
                  >
                    Divyakshetra Hariharapura
                  </span>
                </div>
                <div className="slider-area">
                  <div
                    className="swiper th-slider has-shadow"
                    id="cousrseSlide"
                    data-slider-options='{"loop":true,"breakpoints":{"0":{"slidesPerView":1},"576":{"slidesPerView":"1"},"768":{"slidesPerView":"1"},"992":{"slidesPerView":"2"},"1300":{"slidesPerView":"3"}}}'
                  >
                    <div className="swiper-wrapper">






                      <Swiper
                        modules={[Navigation, Autoplay]}
                        loop={true}
                        speed={2500}
                        autoplay={{
                          delay: 6000,
                          disableOnInteraction: false,
                        }}
                        navigation={{
                          nextEl: ".slider-next",
                          prevEl: ".slider-prev",
                        }}
                        breakpoints={{
                          0: { slidesPerView: 1 },
                          576: { slidesPerView: 1 },
                          768: { slidesPerView: 1 },
                          992: { slidesPerView: 2 },
                          1300: { slidesPerView: 3 },
                        }}
                        spaceBetween={20}
                        className="mySwiper"
                      >
                        {[
                          "assets/img/others/11.jpg",
                          "assets/img/others/7.jpg",
                          "assets/img/others/18.jpg",
                          "assets/img/others/9.jpg",
                          "assets/img/others/4.jpg",
                          "assets/img/others/6.jpg",
                          "assets/img/others/14.jpg",
                          "assets/img/others/13.jpg",
                          "assets/img/others/17.jpg",
                          "assets/img/others/8.jpg",
                          "assets/img/others/12.jpg",
                          "assets/img/others/1.jpg",
                          "assets/img/others/2.jpg",
                          "assets/img/others/3.jpg",
                          "assets/img/others/5.jpg",
                          "assets/img/others/10.jpg",
                        ].map((img, index) => (
                          <SwiperSlide key={index}>
                            <div className="cousrse-card">
                              <div className="box-img global-img">
                                <img src={img} alt={`Slide ${index}`} />
                              </div>
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>

                      <button className="slider-arrow style2 slider-prev">
                        <i className="fa-thin fa-arrow-left-long"></i>
                      </button>
                      <button className="slider-arrow style2 slider-next">
                        <i className="fa-thin fa-arrow-right-long"></i>
                      </button>





                      {/* <div className="swiper-slide">
                        <div className="cousrse-card">
                          <div className="box-img global-img">
                            <img src="assets/img/others/11.jpg" alt="" />
                          </div>
                          <div className="btn-group justify-content-center">
                            <h6
                              style={{
                                width: "100%",
                                textAlign: "center",
                                marginTop: "-22px",
                              }}
                            ></h6>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="cousrse-card">
                          <div className="box-img global-img">
                            <img src="assets/img/others/7.jpg" alt="" />
                          </div>
                          <div className="btn-group justify-content-center">
                            <h6
                              style={{
                                width: "100%",
                                textAlign: "center",
                                marginTop: "-22px",
                              }}
                            ></h6>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="cousrse-card">
                          <div className="box-img global-img">
                            <img src="assets/img/others/18.jpg" alt="" />
                          </div>
                          <div className="btn-group justify-content-center">
                            <h6
                              style={{
                                width: "100%",
                                textAlign: "center",
                                marginTop: "-22px",
                              }}
                            ></h6>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="cousrse-card">
                          <div className="box-img global-img">
                            <img src="assets/img/others/9.jpg" alt="" />
                          </div>
                          <div className="btn-group justify-content-center">
                            <h6
                              style={{
                                width: "100%",
                                textAlign: "center",
                                marginTop: "-22px",
                              }}
                            ></h6>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="cousrse-card">
                          <div className="box-img global-img">
                            <img src="assets/img/others/4.jpg" alt="" />
                          </div>
                          <div className="btn-group justify-content-center">
                            <h6
                              style={{
                                width: "100%",
                                textAlign: "center",
                                marginTop: "-22px",
                              }}
                            ></h6>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="cousrse-card">
                          <div className="box-img global-img">
                            <img src="assets/img/others/6.jpg" alt="" />
                          </div>
                          <div className="btn-group justify-content-center">
                            <h6
                              style={{
                                width: "100%",
                                textAlign: "center",
                                marginTop: "-22px",
                              }}
                            ></h6>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="cousrse-card">
                          <div className="box-img global-img">
                            <img src="assets/img/others/14.jpg" alt="" />
                          </div>
                          <div className="btn-group justify-content-center">
                            <h6
                              style={{
                                width: "100%",
                                textAlign: "center",
                                marginTop: "-22px",
                              }}
                            ></h6>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="cousrse-card">
                          <div className="box-img global-img">
                            <img src="assets/img/others/13.jpg" alt="" />
                          </div>
                          <div className="btn-group justify-content-center">
                            <h6
                              style={{
                                width: "100%",
                                textAlign: "center",
                                marginTop: "-22px",
                              }}
                            ></h6>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="cousrse-card">
                          <div className="box-img global-img">
                            <img src="assets/img/others/17.jpg" alt="" />
                          </div>
                          <div className="btn-group justify-content-center">
                            <h6
                              style={{
                                width: "100%",
                                textAlign: "center",
                                marginTop: "-22px",
                              }}
                            ></h6>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="cousrse-card">
                          <div className="box-img global-img">
                            <img src="assets/img/others/8.jpg" alt="" />
                          </div>
                          <div className="btn-group justify-content-center">
                            <h6
                              style={{
                                width: "100%",
                                textAlign: "center",
                                marginTop: "-22px",
                              }}
                            ></h6>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="cousrse-card">
                          <div className="box-img global-img">
                            <img src="assets/img/others/12.jpg" alt="" />
                          </div>
                          <div className="btn-group justify-content-center">
                            <h6
                              style={{
                                width: "100%",
                                textAlign: "center",
                                marginTop: "-22px",
                              }}
                            ></h6>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="cousrse-card">
                          <div className="box-img global-img">
                            <img src="assets/img/others/1.jpg" alt="" />
                          </div>
                          <div className="btn-group justify-content-center">
                            <h6
                              style={{
                                width: "100%",
                                textAlign: "center",
                                marginTop: "-22px",
                              }}
                            ></h6>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="cousrse-card">
                          <div className="box-img global-img">
                            <img src="assets/img/others/2.jpg" alt="" />
                          </div>
                          <div className="btn-group justify-content-center">
                            <h6
                              style={{
                                width: "100%",
                                textAlign: "center",
                                marginTop: "-22px",
                              }}
                            ></h6>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="cousrse-card">
                          <div className="box-img global-img">
                            <img src="assets/img/others/3.jpg" alt="" />
                          </div>
                          <div className="btn-group justify-content-center">
                            <h6
                              style={{
                                width: "100%",
                                textAlign: "center",
                                marginTop: "-22px",
                              }}
                            ></h6>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="cousrse-card">
                          <div className="box-img global-img">
                            <img src="assets/img/others/5.jpg" alt="" />
                          </div>
                          <div className="btn-group justify-content-center">
                            <h6
                              style={{
                                width: "100%",
                                textAlign: "center",
                                marginTop: "-22px",
                              }}
                            ></h6>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="cousrse-card">
                          <div className="box-img global-img">
                            <img src="assets/img/others/10.jpg" alt="" />
                          </div>
                          <div className="btn-group justify-content-center">
                            <h6
                              style={{
                                width: "100%",
                                textAlign: "center",
                                marginTop: "-22px",
                              }}
                            ></h6>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                  <button
                    data-slider-prev="#cousrseSlide"
                    className="slider-arrow style2 slider-prev"
                  >
                    <i className="fa-thin fa-arrow-left-long"></i>
                  </button>
                  <button
                    data-slider-next="#cousrseSlide"
                    className="slider-arrow style2 slider-next"
                  >
                    <i className="fa-thin fa-arrow-right-long"></i>
                  </button>
                </div>
              </div>
            </div>
            <div
              className="overflow-hidden position-relative overflow-hidden"
              id="about-sec"
              style={{
                backgroundImage: "url(assets/img/guru_bg.png)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                padding: "40px 0",
              }}
            >
              <div className="container">
                <div className="row align-items-center justify-content-center">
                  <div className="mt-5 pe-xl-5 me-xl-5 text-center">
                    <span className="sub-title text-anime-style-2 text-white">
                      Kshetra Mahima
                    </span>
                    <h2
                      className="sec-title text-anime-style-3"
                      style={{ color: "#ffd54f" }}
                    >
                      Siddha Kshetra
                    </h2>
                  </div>
                  <div className="col-xxl-6">
                    <p
                      className="mb-15 fs-18 wow fadeInUp"
                      data-wow-delay=".2s"
                      style={{ color: "#fff" }}
                    >
                      According to the agama shastras, the northern direction is
                      auspicious for success in spiritual practices, and the river
                      Tunga majestically flows northward as Uttaravahini here.
                      Hence, this place is also known as Siddakshetra. Taking a
                      sojourn to Divyakshetra Hariharapura and performing homa,
                      japa, meditation, or any kind of worship or sadhana is
                      considered very auspicious and known to grant
                      manifold benefits
                    </p>
                  </div>
                  <div
                    className="col-xxl-6 d-flex justify-content align-items-center"
                  >
                    <div
                      className="img-box2 pe-xl-5 me-xl-2 d-flex justify-content align-items-cente"
                    >
                      <div className="img1 d-flex justify-content align-items-center">
                        <img
                          style={{ width: "100%" }}
                          src="assets/img/about/sidhakshetra.jpg"
                          alt="About"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="pe-xl-5 me-xl-5 text-center">
                    <h2
                      className="sec-title text-anime-style-3 mt-5"
                      style={{ color: "#ffd54f" }}
                    >
                      Yaga Bhoomi
                    </h2>
                  </div>
                  <div
                    className="col-xxl-6 d-flex justify-content align-items-center"
                  >
                    <div
                      className="img-box2 pe-xl-5 me-xl-2 d-flex justify-content align-items-cente"
                    >
                      <div className="img1 d-flex justify-content align-items-center">
                        <img src="assets/img/about/yagabhumi.png" alt="About" />
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-6">
                    <p
                      className="mb-15 fs-18 wow fadeInUp"
                      data-wow-delay=".2s"
                      style={{ color: "#fff" }}
                    >
                      The sacred region, now known as Dakshashrama, is steeped in
                      divine history. As per Skaanda Purana in Sahyadri Khanda, it
                      was here that Shri Daksha Prajapati conducted the monumental
                      Maha Yagna. During this grand sacrifice, Sri Dakshahara
                      Someshwara emerged directly from the holy Yagna Kunda.
                    </p>
                    <p
                      className="mt-5 mb-15 fs-18 wow fadeInUp"
                      data-wow-delay=".2s"
                      style={{ color: "#fff" }}
                    >
                      This divine manifestation is a testament to the Lord’s
                      profound compassion and the re-establishment of cosmic
                      harmony, achieved through Daksha's rigorous penance and
                      unwavering devotion. The powerful spiritual vibrations from
                      this sacred event are believed to resonate in this land even
                      today, imbuing it with immense spiritual energy and
                      sanctity.
                    </p>
                    <p
                      className="mt-5 mb-15 fs-18 wow fadeInUp"
                      data-wow-delay=".2s"
                      style={{ color: "#fff" }}
                    >
                      In commemoration of the divine Yagna performed on this site,
                      it became renowned as Yagabhoomi, or the "Land of the Sacred
                      Sacrifice." Devotees continue to believe that worship at
                      this Kshetra bestows spiritual merit, mental purity, and the
                      blessings of Lord Someshwara, who dispels ego and ignorance.
                    </p>
                    <p
                      className="mt-5 mb-15 fs-18 wow fadeInUp"
                      data-wow-delay=".2s"
                      style={{ color: "#fff" }}
                    >
                      The ancient temple of Swayambhu Sri DakshaHara Someshawara
                      at Divyakshetra Hariharapura, is a testimony to this puranic
                      legend and is worshipped to this day.
                    </p>
                  </div>
                  <div className="mt-5 pe-xl-5 me-xl-5 text-center">
                    <h2
                      className="sec-title text-anime-style-3"
                      style={{ color: "#ffd54f" }}
                    >
                      Tapo Bhoomi
                    </h2>
                  </div>
                  <div className="col-xxl-6">
                    <p
                      className="mb-15 fs-18 wow fadeInUp"
                      data-wow-delay=".2s"
                      style={{ color: "#fff" }}
                    >
                      Mahatapaswi Sri Agastya Maharishi, performed severe penance
                      and had the divine darshan of Sri Lakshmi Narasimha Swamy.
                      Inspired by the tapas-siddhi of Sri Agastya Mahrishi, and
                      with the direct appearance of Sri Lakshmi Narasimha, this
                      place is known as Tapobhoomi.
                    </p>
                    <p
                      className="mt-5 mb-15 fs-18 wow fadeInUp"
                      data-wow-delay=".2s"
                      style={{ color: "#fff" }}
                    >
                      The Lakshmi Narasimha saligrama and vigraha worshiped by Sri
                      Agastya Maharishi is still enshrined and worshiped at the
                      temple to this day.
                    </p>
                    <p
                      className="mt-5 mb-15 fs-18 wow fadeInUp"
                      data-wow-delay=".2s"
                      style={{ color: "#fff" }}
                    >
                      This unique temple houses 2 sanctum sanctorums of Sri
                      Lakshmi Narasimha. The lower Sanctom Sanctorum houses the
                      32-feet Lakshmi-Narasimha Mahayantra in the form of a pillar
                      known as Vajrasthamba. Atop, at the bindu-staana of the
                      powerful vajrasthamba resides the auspicious Laskhmi
                      Narasimha Swamy idol carved out of Margatha stone. As
                      expounded in our scriptures, "Sthambhavat Drishyate Harih",
                      Lord Sri Lakshmi Narasimha Swamy in his most benevolent and
                      auspicious form, dwells gloriously atop the vajrasthamba
                      yantra as poorna chaitanya murthy.
                    </p>
                  </div>
                  <div
                    className="col-xxl-6 d-flex justify-content align-items-center"
                  >
                    <div
                      className="img-box2 pe-xl-5 me-xl-2 d-flex justify-content align-items-cente"
                    >
                      <div className="img1 d-flex justify-content align-items-center">
                        <img src="assets/img/about/tapobhumi.png" alt="About" />
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 pe-xl-5 me-xl-5 text-center">
                    <h2
                      className="sec-title text-anime-style-3"
                      style={{ color: "#ffd54f" }}
                    >
                      Jnana Bhoomi
                    </h2>
                  </div>
                  <div
                    className="col-xxl-6 d-flex justify-content align-items-center"
                  >
                    <div
                      className="img-box2 pe-xl-5 me-xl-2 d-flex justify-content align-items-cente"
                    >
                      <div className="img1 d-flex justify-content align-items-center">
                        <img
                          src="assets/img/about/jnanabhumi-1.png"
                          alt="About"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-6">
                    <p
                      className="mb-15 fs-18 wow fadeInUp"
                      data-wow-delay=".2s"
                      style={{ color: "#fff" }}
                    >
                      This sacred land holds the divine footprints of Jagadguru
                      Adi Shankaracharya Bhagavatpada, the great spiritual
                      reformer and propagator of Sanatana Dharma. During His holy
                      travels across the Bharata Desha to revive Vedic wisdom and
                      establish the supremacy of Advaita Siddhanta, Adi
                      Shankaracharya visited this very region and recognized its
                      immense spiritual potency.
                    </p>
                    <p
                      className="mt-5 mb-15 fs-18 wow fadeInUp"
                      data-wow-delay=".2s"
                      style={{ color: "#fff" }}
                    >
                      Here, the revered Acharya installed the sacred Sri Chakra
                      Yantra—the most powerful symbol of the Divine Mother’s
                      energy—thereby invoking the blessings of Goddess Sri Sharada
                      Parameshwari, the embodiment of supreme knowledge,
                      compassion, and divine power. Through His spiritual vision
                      and divine consecration (Pratishta), this land was
                      transformed into a radiant center of Jnana (wisdom) and
                      Bhakti (devotion).
                    </p>
                    <p
                      className="mt-5 mb-15 fs-18 wow fadeInUp"
                      data-wow-delay=".2s"
                      style={{ color: "#fff" }}
                    >
                      It was at this very place that Adi Shankaracharya bestowed
                      Mantra Deeksha upon Sri Swayamprakasha Krishna Yogeendra
                      Mahaswamiji, who later became the first Peethadipathi
                      (Pontiff) of this sacred Dharmapeetham. From that moment
                      onward, the divine lineage of enlightened Gurus continued,
                      preserving and spreading the eternal light of Advaita
                      Vedanta and the worship of Sri Sharada Parameshwari for
                      generations to come.
                    </p>
                  </div>
                  <div className="col-xxl-6">
                    <p
                      className="mb-15 fs-18 wow fadeInUp"
                      data-wow-delay=".2s"
                      style={{ color: "#fff" }}
                    >
                      From that divine moment onward, the illustrious lineage of
                      the Guru Parampara—beginning with the blessings of Jagadguru
                      Adi Shankaracharya Bhagavatpada and the sacred initiation of
                      Sri Swayamprakasha Krishna Yogeendra Mahaswamiji—has
                      continued unbroken through the ages. Each Peethadipathi of
                      this Dharmapeetham has carried forward the radiant light of
                      Jnana (spiritual wisdom), Bhakti (devotion), and Dharma
                      (righteousness), guiding countless seekers on the path of
                      truth and liberation.
                    </p>
                    <p
                      className="mt-5 mb-15 fs-18 wow fadeInUp"
                      data-wow-delay=".2s"
                      style={{ color: "#fff" }}
                    >
                      Through their divine presence, selfless service, and
                      profound teachings, the Guru Parampara has nourished this
                      sacred land with the essence of Vedic knowledge and Advaitic
                      realization. The spiritual vibrations established by their
                      penance, prayers, and blessings continue to fill this region
                      with divine energy and serenity.
                    </p>
                    <p
                      className="mt-5 mb-15 fs-18 wow fadeInUp"
                      data-wow-delay=".2s"
                      style={{ color: "#fff" }}
                    >
                      Thus, this Divya Kshetra of Divyakshetra Hariharapura came
                      to be revered as Jnanabhoomi—the “Land of Divine Wisdom.” It
                      stands as a shining beacon of spiritual heritage, where
                      Jnana, Bhakti, and Seva harmoniously unite, inspiring
                      generations to walk the path of enlightenment and eternal
                      truth.
                    </p>
                  </div>
                  <div
                    className="col-xxl-6 d-flex justify-content align-items-center"
                  >
                    <div
                      className="img-box2 pe-xl-5 me-xl-2 d-flex justify-content align-items-cente"
                    >
                      <div className="img1 d-flex justify-content align-items-center">
                        <img
                          src="assets/img/about/jyanabhumi-2.png"
                          alt="About"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="d-flex justify-content-center"
        style={{
          backgroundImage: "url(assets/img/bg/frame_1.png)",
          backgroundPosition: "center",
        }}
      >
        <div
          className="d-flex justify-content-center video-wrapper"
          style={{ maxWidth: "600px", position: "relative" }}
        >
          <button
            id="unmuteBtn"
            aria-label="Unmute"
            title="Unmute"
            style={{
              display: "none",
              position: "absolute",
              right: "10px",
              bottom: "10px",
              zIndex: 5,
              background: "rgba(255, 255, 255, 0.95)",
              border: "none",
              padding: "8px 12px",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            Unmute
          </button>
        </div>
      </div>
      <section
        className="bg-theme overflow-hidden space overflow-hidden"
        data-bg-src="assets/img/bg/event_bg_shape.html"
      >
        <div className="container">
          <div className="row gy-4 gx-40">
            <div className="pe-xl-5 me-xl-5 text-center">
              <span
                className="sub-title text-anime-style-2 m-auto"
                style={{ color: "#840000" }}
              >
                Guru Parampara
              </span>
              <h2 style={{ color: "#840000" }}>
                सदाशिवसमारम्भां शङ्कराचार्यमध्यमाम् ।
              </h2>
              <h2 style={{ color: "#840000" }}>
                अस्मदाचार्यपर्यन्तां वन्दे गरुपरम्पराम् ॥
              </h2>
            </div>
            <img
              src="assets/img/guru-parampara/guru-parampara-1920.jpg"
              style={{ borderRadius: "30px" }}
              alt=""
            />
            <div className="container">
              <div className="row align-items-center mb-5">
                <div className="col-xl-6">
                  <div className="event-card wow fadeInLeft" data-wow-delay=".3s">
                    <div className="box-img global-img">
                      <img
                        src="assets/img/guru-parampara/narashimha.jpg"
                        alt="Narasimha"
                      />
                    </div>
                    <div className="box-content">
                      <h5 className="box-title">
                        उपास्महे नृसिंहाख्यं ब्रह्मवेदान्तगोचरम् ।
                        भूयोल्लासितसंसारच्छेदहेतुं जगद्गुरुम् ॥
                      </h5>
                      <h6>
                        upāsmahe nṛsimhākhyaṃ brahmavedāntagocaram ∣
                        bhūyollāsitasaṃsāracchedahetuṃ jagadgurum ∥1∥
                      </h6>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6">
                  <p
                    className="mb-15 fs-18 wow fadeInUp"
                    data-wow-delay=".2s"
                    style={{ color: "#840000" }}
                  >
                    <i>
                      "We worship
                      <b>Lord Nṛsiṃha</b>
                      , who is comprehended through the teachings of the Vedas and
                      Vedānta, the Supreme Teacher of the universe, who is the
                      cause for the complete destruction of the vast and terrible
                      cycle of worldly existence (saṃsāra)."
                    </i>
                  </p>
                </div>
              </div>
              <div className="row align-items-center mb-5">
                <div className="col-xl-6 order-xl-2">
                  <div className="event-card wow fadeInRight" data-wow-delay=".3s">
                    <div className="box-img global-img">
                      <img
                        src="assets/img/guru-parampara/agastya.jpg"
                        alt="Agastya"
                      />
                    </div>
                    <div className="box-content">
                      <h5 className="box-title">
                        दक्षाश्रमे तपः कृत्वा येन साक्षात्कृतो हरिः ।
                        नृसिंहभक्तप्रवरमगस्त्यं प्रणमाम्यहम् ॥
                      </h5>
                      <h6>
                        dakṣāśrame tapaḥ kṛtvā yena sākṣātkṛto hariḥ ∣
                        nṛsiṃhabhaktapravaramagastyaṃ praṇamāmyaham ∥2∥
                      </h6>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 order-xl-1">
                  <p
                    className="mb-15 fs-18 wow fadeInUp"
                    data-wow-delay=".2s"
                    style={{ color: "#840000" }}
                  >
                    <i>
                      "I bow down to the great
                      <b>Sage Agastya</b>
                      , the foremost among the devotees of Lord Nṛsiṃha, who, by
                      performing intense penance in the hermitage of Dakṣa,
                      realized Lord Hari directly."
                    </i>
                  </p>
                </div>
              </div>
              <div className="row align-items-center mb-5">
                <div className="col-xl-6">
                  <div className="event-card wow fadeInLeft" data-wow-delay=".3s">
                    <div className="box-img global-img">
                      <img
                        src="assets/img/guru-parampara/shankaracharya.jpg"
                        alt="Shankaracharya"
                      />
                    </div>
                    <div className="box-content">
                      <h5 className="box-title">
                        श्रुतिस्मृतिपुराणानामालयं करुणालयम् । नमामि भगवत्पादं
                        शङ्करं लोकशङ्करम् ॥
                      </h5>
                      <h6>
                        śrutismṛtipurāṇānāmālayaṃ karuṇālayam ∣ namāmi
                        bhagavatpādaṃ śaṅkaraṃ lokaśaṅkaram ∥3∥
                      </h6>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6">
                  <p
                    className="mb-15 fs-18 wow fadeInUp"
                    data-wow-delay=".2s"
                    style={{ color: "#840000" }}
                  >
                    <i>
                      "I bow down to
                      <b>Bhagavatpāda Śaṅkara</b>
                      — the abode of the Śruti (Vedas), Smṛti, and Purāṇas, the
                      very embodiment of compassion, and the one who brings
                      auspiciousness to the entire world."
                    </i>
                  </p>
                </div>
              </div>
              <div className="row align-items-center mb-5">
                <div className="col-xl-6 order-xl-2">
                  <div className="event-card wow fadeInRight" data-wow-delay=".3s">
                    <div className="box-img global-img">
                      <img
                        src="assets/img/guru-parampara/sureshwaracharya.jpg"
                        alt="Sureshwaracharya"
                      />
                    </div>
                    <div className="box-content">
                      <h5 className="box-title">
                        वन्देऽहं शङ्कराचार्यसच्छिष्यम् ज्ञानसागरम् । सुरेश्वरं
                        गरुं धीरं धर्मब्रह्मविदुत्तमम् ॥
                      </h5>
                      <h6>
                        vande’haṃ śaṅkarācāryasacchiṣyaṃ jñānasāgaram ∣ sureśvaraṃ
                        guruṃ dhīraṃ dharmabrahmaviduttamam ∥4∥
                      </h6>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 order-xl-1">
                  <p
                    className="mb-15 fs-18 wow fadeInUp"
                    data-wow-delay=".2s"
                    style={{ color: "#840000" }}
                  >
                    <i>
                      "I bow to the noble
                      <b>Guru Sureśvara</b>
                      — the true disciple of Śrī Śaṅkarācārya, an ocean of wisdom,
                      steadfast and composed, the supreme knower of Dharma and
                      Brahman."
                    </i>
                  </p>
                </div>
              </div>
              <div className="row align-items-center mb-5">
                <div className="col-xl-6 col-lg-8 col-md-10 mx-auto">
                  <div
                    className="event-card text-center wow fadeInUp"
                    data-wow-delay=".3s"
                  >
                    <div className="box-img global-img">
                      <img
                        src="assets/img/guru-parampara/g1.jpg"
                        alt="MahaSwamiji"
                      />
                    </div>
                    <div className="box-content">
                      <h4>
                        Sri Swayamprakasha Krishna Yogeendra Saraswathi
                        MahaSwamiji
                      </h4>
                      <h5 className="box-title">
                        सौराष्ट्रेषु जनिं प्राप्य दक्षाश्रममुपागताः तुङ्गातीरे तपोनुष्ठा: आदिशङ्करदीक्षिताः । अतोप्यधिकतेजसः श्री
                        कृष्णयोगीन्द्रवराः सदा शिष्योपदेशकाः तान् विनीतो नमाम्यहम्
                        ॥
                      </h5>
                      <h6>
                        saurāṣtreṣu janiṃ prāpya dakṣāśramamupāgatāḥ tuṅgātīre
                        taponiṣṭhāḥ ādiśaṅkaradīkṣitāḥ ∣ atopyadhikatejasaḥ
                        śrīkṛṣṇayogīndravarāḥ sadā śiṣyopadeśakāḥ tān vinīto
                        namāmyaham ∥5∥
                      </h6>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 order-xl-1">
                  <p
                    className="mb-15 fs-18 wow fadeInUp"
                    data-wow-delay=".2s"
                    style={{ color: "#840000" }}
                  >
                    <i>
                      "Born in the land of Saurāṣṭra and later arriving at the
                      hermitage of Dakṣa, they performed intense austerities on
                      the banks of the river Tuṅgā and were initiated by Ādi
                      Śaṅkarācārya. Among them, the most radiant and exalted was
                      <b>Śrī Kṛṣṇa Yogīndra</b>
                      , ever engaged in mentoring disciples. To that venerable
                      teacher, I bow down with humility."
                    </i>
                  </p>
                </div>
              </div>
              <div className="row align-items-center mb-5">
                <div className="col-xl-6">
                  <p className="mb-15 fs-18 wow fadeInUp" style={{ color: "#840000" }}>
                    <i>
                      "I worship that noble Guru,
                      <b>Śrī Rāmānanda Yatīśvara</b>
                      — the worthy recipient of Goddess Śāradā’s grace and
                      compassion, the revered spiritual master and head of
                      Puṅganūru."
                    </i>
                  </p>
                </div>
                <div className="col-xl-6">
                  <div
                    className="event-card text-center wow fadeInUp"
                    data-wow-delay=".3s"
                  >
                    <div className="box-img global-img">
                      <img
                        src="assets/img/guru-parampara/g3.jpg"
                        alt="MahaSwamiji"
                      />
                    </div>
                    <div className="box-content">
                      <h4>
                        Sri Swayamprakasha Ramananda Saraswathi MahaSwamiji – III
                      </h4>
                      <h5 className="box-title">
                        शारदाकरुणापात्रं रामानन्दयतीश्वरम् । पुङ्गनूरुपुराधीशं
                        सद्गुरुं तमहं भजे ॥
                      </h5>
                      <h6>
                        śāradākaruṇāpātraṃ rāmānandayatīśvaram ∣
                        puṅganūrupurādhīśaṃ sadguruṃ tamahaṃ bhaje ∥27∥
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row align-items-center mb-5">
                <div className="col-xl-6 order-xl-2">
                  <p
                    className="mb-15 fs-18 wow fadeInUp"
                    data-wow-delay=".2s"
                    style={{ color: "#840000" }}
                  >
                    <i>
                      "I adore my Guru,
                      <b>Śrī Rāmānanda</b>
                      — the ever-youthful master of Hariharapura, who is deeply
                      devoted to the worship of the sacred Śrīcakra."
                    </i>
                  </p>
                </div>
                <div className="col-xl-6 order-xl-1">
                  <div
                    className="event-card text-center wow fadeInUp"
                    data-wow-delay=".3s"
                  >
                    <div className="box-img global-img">
                      <img
                        src="assets/img/guru-parampara/g2.jpg"
                        alt="MahaSwamiji"
                      />
                    </div>
                    <div className="box-content">
                      <h4>
                        Sri Swayamprakasha Abhinava Ramananda Saraswathi
                        MahaSwamiji
                      </h4>
                      <h5 className="box-title">
                        हरिहरपुराधीशं श्रीचक्रार्चनतत्परम् । सदाभिनवपूर्वं तं
                        रामानन्दगरुं भजे ॥
                      </h5>
                      <h6>
                        hariharapurādhīśaṃ śrīcakrārcanatatparam ∣
                        sadābhinavapūrvaṃ taṃ rāmānandaguruṃ bhaje ∥28∥
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="row justify-content-center p-5">
        <div className="col-lg-12">
          <h2 className="sec-title mt-40 text-center">
            त्यागमूर्तिं तपोनिष्ठं शारदार्चनतत्परम् ।
            <br />
            सच्चिदानन्दयोगीन्द्रं प्रत्यहं प्रणमाम्यहम् ॥
          </h2>
        </div>
        <div className="col-lg-6">
          <div className="pe-lg-4 me-lg-3">
            <div className="title-area style3">
              <h2 className="sec-title text-anime-style-3 mt-40">
                The Jagadguru Shankaracharya of Divyakshetra Hariharapura
              </h2>
            </div>
            <p className="mt-n2 mb-35 fs-18 wow fadeInUp" data-wow-delay=".3s">
              Anantha Sri Vibushita Jagadguru Shankaracharya Parama Pujya Sri Sri
              Swayamprakasha Sachidananda Saraswati Mahaswamiji is the present
              Peethadipati of this esteemed Dharma Peetham. Mahaswamiji has
              transformed the ancient mutt into a magnificent temple. This unique
              temple houses 2 Sanctum Sanctorum (Garbha Grihas) of Sri Lakshmi
              Narasimha. The lower Sanctum Sanctorum houses a 32-feet
              Lakshmi-Narasimha Mahayantra in the form of a pillar known as
              Vajrasthamba. Atop at the Bindu-staana of the powerful Vajrasthamba
              enshrines the auspicious Lakshmi Narasimha Swamy, meticulously
              carved from Maragatha stone.
            </p>
            <p className="mt-n2 mb-35 fs-18 wow fadeInUp" data-wow-delay=".4s">
              Mahaswamiji has initiated countless devotees into Shiva Deeksha,
              emphasizing the principles of "All are one," "All are equal," and
              "All are divine." He embodies a unique blend of austerity and
              unconditional love, guiding numerous devotees. His mission is to
              inspire people towards devotion to God and our Motherland, Bharath.
            </p>
          </div>
        </div>
        <div className="col-lg-6">
          <img src="assets/img/about/swamiji.jpg" alt="" />
        </div>
        <div
          className="col-lg-6"
          style={{
            backgroundImage: "url(assets/img/bg/frame_1.png)",
            backgroundPosition: "center",
          }}
        >
          <h2 className="sec-title mt-40 text-center">गुरुबिरुदावलिः</h2>
          <h5 className="sec-title mt-40 text-center">
            श्रीमत्परमहंसपरिव्राजकाचार्यवर्य
            <br />
            पदवाक्यप्रमाणपारावारपारीण
            <br />
            यमनियमासनप्राणायामप्रत्याहारधारणाध्यानसमाध्यष्टाङ्गयोगानुष्ठाननिष्ठ
            <br />
            तपश्चक्रवर्ती
            <br />
            अनाद्यविच्छिन्नश्रीशङ्कराचार्यगुरुपरम्पराप्राप्त
            <br />
            सकलनिगमागमसारहृदय
            <br />
            साङ्ख्यत्रयप्रतिपादक
            <br />
            वैदिकमार्गप्रवर्तक
            <br />
            व्याख्यानगुरुसिंहासनारूढ
            <br />
            तुङ्गभद्रातीरदक्षाश्रमवासा
            <br />
            हरिहरपुरवराधीश्वर श्रीआदिशङ्कराचार्य श्रीशारदालक्ष्मीनृसिंह
            पादपद्माराधक
            <br />
            श्रीस्वयंप्रकाशाभिनवरामानन्दसरस्वतीगुरुकरकमलसंजात
            <br />
            हरिहरपुरदिव्यक्षेत्रपुनर्निर्माणदक्ष
            <br />
            परमपूज्य श्रीमज्जगद्गुरुशङ्कराचार्य
            श्रीश्रीस्वयम्प्रकाशसच्चिदानन्दसरस्वती महास्वामिनां
            <br />
            चरणारविन्दयोः
            <br />
            साष्टाङ्गप्रणमान् समर्पयामः ॥
            <br />
          </h5>
        </div>
        <div
          className="col-lg-6"
          style={{
            backgroundImage: "url(assets/img/bg/frame_1.png)",
            backgroundPosition: "center",
          }}
        >
          <h2 className="sec-title mt-40 text-center">ಗುರುಬಿರುದಾವಳಿ</h2>
          <h6 className="sec-title mt-40 text-center">
            ಶ್ರೀಮತ್ ಪರಮಹಂಸ ಪರಿವ್ರಾಜಕಾಚಾರ್ಯವರ್ಯ
            <br />
            ಪದವಾಕ್ಯ ಪ್ರಮಾಣ ಪಾರಾವಾರ ಪಾರಿಣ
            <br />
            ಯಮನಿಯಮಾಸನ ಪ್ರಾಣಾಯಾಮ ಪ್ರತ್ಯಾಹಾರ ಧಾರಣಧ್ಯಾನ ಸಮಾಧಿ ಅಷ್ಟಾಂಗಯೋಗಾನುಷ್ಠಾನ
            ನಿಷ್ಠ
            <br />
            ತಪಶ್ಚಕ್ರವರ್ತಿ
            <br />
            ಅನಾದ್ಯವಿಚ್ಛಿನ್ನ ಶ್ರೀ ಶಂಕರಾಚಾರ್ಯ ಗುರುಪರಂಪರಾ ಪ್ರಾಪ್ತ
            <br />
            ಸಕಲನಿಗಮಾಗಮಸಾರಹೃದಯ
            <br />
            ಸಾಂಖ್ಯತ್ರಯ ಪ್ರತಿಪಾದಕ
            <br />
            ವೈದಿಕ ಮಾರ್ಗ ಪ್ರವರ್ತಕ
            <br />
            ವ್ಯಾಖ್ಯಾನ ಗುರುಸಿಂಹಾಸನಾರೂಢ
            <br />
            ತುಂಗಭದ್ರಾ ತೀರ ದಕ್ಷಾಶ್ರಮವಾಸಿ
            <br />
            ಹರಿಹರಪುರವರಾಧೀಶ್ವರ ಶ್ರೀ ಆದಿಶಂಕರಾಚಾರ್ಯ ಶ್ರೀ ಶಾರದಾ ಲಕ್ಷ್ಮೀನೃಸಿಂಹ ಪಾದಪದ್ಮಆರಾಧಕ
            <br />
            ಶ್ರೀ ಸ್ವಯಂಪ್ರಕಾಶ ಅಭಿನವರಾಮಾನಂದ ಸರಸ್ವತಿ ಗುರುಕರಕಮಲ ಸಂಜಾತ
            <br />
            ಹರಿಹರಪುರ ದಿವ್ಯಕ್ಷೇತ್ರ ಪುನರ್‌ನಿರ್ಮಾಣ ದಕ್ಷ
            <br />
            ಪರಮಪೂಜ್ಯ ಶ್ರೀಮತ್ ಜಗದ್ಗುರು ಶಂಕರಾಚಾರ್ಯ ಶ್ರೀಶ್ರೀ ಸ್ವಯಂಪ್ರಕಾಶ ಸಚ್ಚಿದಾನಂದ
            ಸರಸ್ವತಿ ಮಹಾಸ್ವಾಮಿನಾಂ
            <br />
            ಚರಣಾರವಿಂದಯೋಃ
            <br />
            ಸಾಷ್ಟಾಂಗ ಪ್ರಣಾಮಂ ಸಮರ್ಪಯಾಮಃ ॥
            <br />
          </h6>
        </div>
        <div className="col-lg-12">
          <h4 className="text-center mt-5">Audio</h4>
          <div className="d-flex" style={{ justifyContent: "center" }}>
            <audio controls style={{ width: "50%", marginTop: "20px" }}>
              <source src="assets/audio/birudhavali.mpeg" type="audio/mpeg" />
            </audio>
          </div>
        </div>
      </div>
      <div className="row justify-content-center p-5">
        <div className="col-lg-6">
          <div className="about-feature style4 wow fadeInUp" data-wow-delay=".4s">
            <div className="box-icon">
              <img src="assets/img/icon/temples.png" alt="Icon" />
            </div>
            <div className="media-body">
              <h3 className="box-title">Historical Records</h3>
              <p className="box-text">
                Historic sources mention Divyakshetra Hariharapura to have been an
                Agrahara ruled by Harihara Maharaya, the second ruler of the
                Vijayanagara Empire. As per the 14th Century inscriptions, the
                place was renovated by the Maharaya and was named after him.
                Harihara Maharaya and the other Rulers.
              </p>
              <p className="box-text">
                ‘ From the inscriptions at the place, it appears to have been an
                Agrahara established in 1418 by Sambanna Wodeyar in the reign of
                King Harihararaya of Vijayanagara kingdom and later named after
                him. The religious establishment at Sringeri was intimately
                connected with the foundation Vijayanagar empire. And King
                Harihararaaya, one of the brothers from whom the Royal line had
                descended, gave his name to the Agrahara of Hariharapura’.
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-6 d-flex justify-content-center align-items-center">
          <img
            style={{ width: "90%", height: "100%" }}
            src="assets/img/about/Histry.png"
            alt=""
          />
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default About;
